import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useUserRoleContext } from "context/NetworkContext";
import { handleRoleBasedNavigation } from "./RoleBasedNavigationUtil";

const withRoleBasedAccess = (WrappedComponent: React.ComponentType<any>, allowedRoles: string[]) => {
  const RoleBasedAccess = (props: any) => {
    const { userRole } = useUserRoleContext();
    const navigate = useNavigate();
    const [hasAccessDecisionBeenMade, setHasAccessDecisionBeenMade] = useState(false);
    const [hasAccess, setHasAccess] = useState(false);

    useEffect(() => {
      if (!userRole) {
        return;
      }

      const navigationResult = handleRoleBasedNavigation(userRole, allowedRoles, navigate);
      setHasAccess(navigationResult === false);
      setHasAccessDecisionBeenMade(true);
    }, [allowedRoles, navigate, userRole]);

    if (!hasAccessDecisionBeenMade || !hasAccess) {
      return null;
    }

    return <WrappedComponent {...props} />;
  };

  return RoleBasedAccess;
};

export default withRoleBasedAccess;
